var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKakheti(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.454,
    height: 79.889,
    viewBox: "0 0 64.454 79.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10364",
    "data-name": "Path 10364",
    d: "M2116.043,1035.776c.723,3.329,4.544,1.5,6.646.9,22.568.808-5.245,15.469,12.431,21.837,4.78.018,2.795,5.107,6.054,4.656,1.084-1.1.865.4,3.545.449,1.158,4.081,5.822-1.849,8.448,3.9,5.17.935,6.152,2.049,2.886,6.752-3.8,6.29-6.164-.933-7.172,5.06-.031,2.269.006,7.346,2.781,4.554,1.253,1.777.814,4.55,2.246,6.175,10.568,7.458,17.408,5.959,10.765,20.122-5.2-1.268-2.288,6.08-7.073.109-4.554-.554-6.123-7.256-11.2-5.232-2.663,4.6-19.894-3.138-14.293-6.4,1.126-.467.2-.739-.385-.963-1.7-.039-6.211-2.023-7.812-2.631-2.832-3.771-6.889,1-7.617-5.893-.56-1.709-2.644-.978-3.735-1.88-1.009-3.583,1.7-5.369-.2-9.694-.382-1.168-.828-1.566-2.083-1.518a10.161,10.161,0,0,1-3.537-4.919c-2.092-.691-.161-1.821.936-2.518,1.723,1.56,2.984,1.349,5.052.924-2.043-3.64-4.96-.539-5.257-4.094.16-5.055-1.253-13.6,4.589-16.42,2.2-.7-.005-4.032.955-5.506C2115.629,1041.5,2113.212,1038.846,2116.043,1035.776Z",
    transform: "translate(-2104.29 -1034.276)",
    fill: "#23262c",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakheti);
export default __webpack_public_path__ + "static/media/kakheti.8bbbe7fdfccab98956e34e3bd4091084.svg";
export { ForwardRef as ReactComponent };